export function getDataAnalyticsService() {
  return window.analyticsService;
}
